export const useNewLocationsLayout = () => {
  return true;
};
